<template lang="pug">
li.d-flex.align-items-center
  img.flex-shrink-0(:src="img")
  p.i_body_l.i_ml_4 {{ text }}
</template>

<script>
export default {
  name: "ListItem",
  props: {
    text: String,
    img: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/product/intro/list_item";
</style>
